import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../../../../layout/Content'
import YearlySalesFooterStyle from './css/YearlySalesFooterStyle'
import ReportsController from '../../../../ReportsController'
import { appContext } from '../../../../../../App'
import { yearlySalesContext } from './YearlySalesController'

function YearlySalesFooter(props) {
  const app = useContext(appContext)
  const yearlySalesController = useContext(yearlySalesContext)
  const [year, setYear] = yearlySalesController.year

  const setContent = app.content[1]

  const onChangeYear = (e) => {
    if (e.target.value.length <= 4) {
      const year = (e.target.value) ? parseInt(e.target.value) : ''
      setYear(year)
     }
  }

  const onClickYearNav = (e) => {
    const btn = e.target.closest('.year-nav-button')
    switch(btn.id) {
      case 'year-nav-left': {
        if (year === 1000) return
        if (year) setYear((prevYear) => prevYear - 1)
        else setYear(9999)
        break
      }
      case 'year-nav-right': {
        if (year === 9999) return
        if (year) setYear((prevYear) => prevYear + 1)
        else setYear(1000)
        break
      }
      default:
    }
  }

  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='add-on-controls'>
          <label htmlFor='year' style={{fontSize: '1rem', margin: 'auto', marginLeft: '0', marginRight: '0'}}>Year:</label>&nbsp;
          <button
            onClick={onClickYearNav}
            id='year-nav-left'
            className='year-nav-button'>
            <FontAwesomeIcon icon='caret-left'/>
          </button>
          <input
            type='number'
            value={year}
            max='9999'
            onChange={onChangeYear}
          />
          <button
            onClick={onClickYearNav}
            id='year-nav-right'
            className='year-nav-button'>
            <FontAwesomeIcon icon='caret-right'/>
          </button>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={() => { setContent(<ReportsController />) }}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Reports
          </button>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={ () => { window.print() } }
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
        </div>
      </div>
      <YearlySalesFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(YearlySalesFooter)
